import React,{useEffect} from 'react';
import '../../css/main.css';
import { TextField } from '@material-ui/core';

function CustomSelect2({ //children, ref,
    id, name, id2, name2,
    defaultValue, defaultValue2,
    codes, comms, items, codeMode, 
    codes2, comms2, items2, codeMode2,
    selectAll, selectAll2, onChange }) {


    useEffect(() => {
        let temp = document.getElementById(id);
        if (temp.options && temp.options[temp.selectedIndex] && temp.options[temp.selectedIndex].text !== '') {
            let e = {
                target: {}
            };
            e.target["name"] = id;
            e.target["value"] = temp && temp.options && temp.options[temp.selectedIndex] ? temp.options[temp.selectedIndex].value : "";
            e.target["desc"] = temp.options[temp.selectedIndex].text;
            if (onChange) {
                onChange(e);
            }
        }
    }, [id,defaultValue]);
    
    const handleChange = (e) => { // 검색조건 변경시 이벤트 처리 - 검색조건
        const { name, value } = e.target;
        let event = {
            target: {}
        };
        event.target["name"] = name;
        event.target["value"] = value;
        event.target["desc"] = e.target[e.target.selectedIndex].text;

        if (onChange) {
            onChange(event);
        }
    };

    return (
        <>
            <div className={"h_LabelL"} style={{ width: "200px"}}>

                <TextField
                    //select1
                    id={id}
                    name={name}
                    className={"k_combo3"}
                    select

                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                    variant="outlined"
                    value={defaultValue}
                    style={{ float: "left", width: "80px",marginRight: "3px" }}
                >

                    {selectAll && selectAll === "none" ?
                        <option key={"selectOne" + id} value={""}>{""}</option>
                        : ""}

                    {selectAll && selectAll === "select" ?
                        <option key={"selectOne" + id} value={""}>{"선택"}</option>
                        : ""}

                    {(selectAll && selectAll === "all") || selectAll === true ?
                        <option key={"selectOne" + id} value={""}>{"전체"}</option>
                        : ""}

                    {/* Case 1 - "Code List" - codes :: codesList */}
                    {codes ? codes.map((option, index) => (
                        < option key={"codesList" + id + index} value={option.comCode}>
                            {codeMode ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}

                    {/* Case 2 - comms :: Search Lis */}
                    {comms ? comms.map((option, index) => (
                        < option key={"commsList" + id + index} value={option.comCode}>
                            {codeMode ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}
                    
                    {/* Case 3 - items :: Hard Coding List */}
                    {items ? items.map((option, index) => (
                        < option key={"itemsList" + id + index} value={option.comCode}>
                            {codeMode ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}

                </TextField>

                <TextField
                    //select2
                    id={id2}
                    name={name2}
                    className={"k_combo3"}
                    select
                  
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                    
                    variant="outlined"
                    value={defaultValue2}
                    style={{ float: "left", width: "65px",marginRight: "3px" }}
                >

                    {selectAll2 && selectAll2 === "none" ?
                        <option key={"selectOne" + id2} value={""}>{""}</option>
                        : ""}

                    {selectAll2 && selectAll2 === "select" ?
                        <option key={"selectOne" + id2} value={""}>{"선택"}</option>
                        : ""}

                    {(selectAll2 && selectAll2 === "all") || selectAll2 === true ?
                        <option key={"selectOne" + id2} value={""}>{"전체"}</option>
                        : ""}

                    {/* Case 1 - "Code List" - codes :: codesList */}
                    {codes2 ? codes2.map((option, index) => (
                        < option key={"codes2List" + id2 + index} value={option.comCode}>
                            {codeMode2 ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}

                    {/* Case 2 - comms :: Search Lis */}
                    {comms2 ? comms2.map((option, index) => (
                        < option key={"comms2List" + id2 + index} value={option.comCode}>
                            {codeMode2 ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}
                    
                    {/* Case 3 - items :: Hard Coding List */}
                    {items2 ? items2.map((option, index) => (
                        < option key={"items2List" + id2 + index} value={option.comCode}>
                            {codeMode2 ? option.comCode + " " : ""}{option.text}
                        </option>
                    )) : ""}

                </TextField>
            </div>
        </>
    );
}

export default CustomSelect2;